import React from 'react';
import facturiIconUrl from '../../NewIcon/facturi.svg';
import marfuriRefrigerateIconUrl from '../../NewIcon/marfuri_refrigerate.svg';
import spvIconUrl from '../../NewIcon/spv.svg';

const SvgImageIcon = ({ src, className = '', width, height, style, ...props }) => (
  <span
    className={className}
    style={{
      display: 'inline-block',
      width,
      height,
      backgroundImage: `url("${src}")`,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      ...style,
    }}
    {...props}
  />
);

export const IconFacturi = (props) => <SvgImageIcon src={facturiIconUrl} {...props} />;
export const IconMarfuriRefrigerate = (props) => <SvgImageIcon src={marfuriRefrigerateIconUrl} {...props} />;
export const IconSpv = (props) => <SvgImageIcon src={spvIconUrl} {...props} />;
